module.exports = __webpack_public_path__ + "static/media/header-logo-qr2gschools.38e5cdab.png";